import { Product } from "./Product";

export enum ProductPropertyKeys {
    User = "User",
    PriceLocked = "PriceLocked"
}

export class ProductProperty implements IProductProperty {
    constructor(property?: IProductProperty, product?: Product) {
        // initialize typed object from generic object
        this._product = product;
        this.key = (property ? property.key : undefined) ?? "";
        this.options = property ? property.options : undefined;
    }

    toJSON(): object {
        // return generic object with properties to stringify
        return {
            key: this.key,
            options: this.options
        };
    }

    key: string;
    options?: string[];

    private _product?: Product;
}

export interface IProductProperty {
    key: string;
    options?: string[];
}